import AcceuilApi from "../api/AcceuilApi";

export default {
    namespaced: true,
    state:{
        acceuils: []
    },
    mutations:{
        setAcceuils(state, acceuils) {
            state.acceuils = acceuils;
        }
    },
    actions: {
        acceuilAllAction({commit}){
            AcceuilApi.acceuilAll()
                .then(res => {
                    commit('setAcceuils',res.data)
                })
        }
    }
}
